import { Component, OnInit } from '@angular/core';
import { SaveService } from '../services/save.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  //-------- brand details ------------
  public brandName;
  public brandUrl;
  public brandEmail;

  constructor(public SaveService: SaveService) {
    document.body.scrollTop = 0;  
   }

  ngOnInit() {
    this.brandName = this.SaveService.getBrandName();
    this.brandUrl = this.SaveService.getBrandUrl();
    this.brandEmail = this.SaveService.getBrandEmail();  
    document.body.scrollTop = 0;    
  }

  slideToggle() {
    try{
      // if(screen.width > 1025){
      //   $('.navbar-nav').css({'padding-top':'25px'});
      // }else{
      //   $('.navbar-nav').css({'padding-top':'0'});
      // }
      $('.navbar-nav').addClass('pad25');//.css({'padding-top':'25px'});
      $('.logo').attr('style');
      var str = window.location.href;
      var n = str.lastIndexOf('/');
      var result = str.substring(n + 1);
      
      if(result != 'Pharmacy'){
        $('.navbar-nav').addClass('pad25');//.css({'padding-top':'25px'});
      }
      if(result != 'howItWorks'){
        $('.navbar-nav').addClass('pad25');//.css({'padding-top':'25px'});
      }
      this.humbergMenu()
    }
    catch{}
  }
  humbergMenu(){
    if (screen.width <= 767) {
      $('.navbar-nav').slideToggle('slow');
      $('.navbar').toggleClass('less');    
      if($('.navbar').hasClass('less')){
        $('#slide-icon').attr('src','assets/images/close.png').delay("slow").fadeIn();
      } else {
        $('#slide-icon').attr('src','assets/images/menu.png').delay("slow").fadeIn();
      }    
    } 
  }
}